import React from "react";
import _ from "lodash";

class ItemsFilter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: "",
    };

    this.inputRef = React.createRef();

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleClearInput = this.handleClearInput.bind(this);
  }

  componentDidMount() {
    if (this.props.inputValue && typeof this.props.inputValue === "string") {
      this.setState({ inputValue: this.props.inputValue });
    }
    this.filterData = _.debounce((event) => {
      this.props.handleSearch(event.target.value);
    }, 300);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isInSearchingMode !== this.props.isInSearchingMode) {
      if (!this.props.isInSearchingMode) {
        this.setState({ inputValue: "" });
      }
    }

    if (prevState.inputValue !== this.state.inputValue) {
      this.props.handleSearch(this.state.inputValue);
    }
  }

  handleOnChange(event) {
    event.persist();
    this.filterData(event);
    this.setState({
      inputValue: event.target.value,
    });
  }

  handleClearInput() {
    this.setState({ inputValue: "" });
  }

  // triggerFilter = true when TAG is inserted
  insertInputValue(value, focusPos = -1, triggerFilter = true) {
    if (!this.inputRef.current) return;

    const input = this.inputRef.current;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const originalValue = input.value;
    const startSpace =
      start !== 0 && originalValue[start - 1] !== " " ? " " : "";
    const endSpace =
      end < originalValue.length && originalValue[end] === " " ? "" : " ";
    const insertValue = `${startSpace}${value}${endSpace}`;
    input.value =
      originalValue.slice(0, start) + insertValue + originalValue.slice(end);
    const newPos =
      start +
      (focusPos < 0 ? insertValue.length : focusPos + startSpace.length);
    input.selectionStart = input.selectionEnd = newPos;
    input.focus();
    if (triggerFilter) {
      this.setState({
        inputValue: input.value,
      });
    }
  }

  render() {
    const { isInSearchingMode, placeholder, isTextArea = false } = this.props;
    const { inputValue } = this.state;

    return isTextArea ? (
      <textarea
        ref={this.inputRef}
        rows={1}
        className={`rounded flex w-full appearance-none border-2 border-gray-300 bg-white px-2 py-1 leading-normal ${
          isInSearchingMode
            ? "border-blue-600"
            : "focus:outline-none hover:shadow hover:border-blue-300 focus:border-blue-400 focus:shadow-inner"
        }`}
        placeholder={placeholder}
        onChange={this.handleOnChange}
        value={inputValue}
      ></textarea>
    ) : (
      <input
        type="text"
        ref={this.inputRef}
        className={`rounded flex w-full appearance-none border-2 border-gray-300 bg-white px-2 py-1 leading-normal ${
          isInSearchingMode
            ? "border-blue-600"
            : "focus:outline-none hover:shadow hover:border-blue-300 focus:border-blue-400 focus:shadow-inner"
        }`}
        placeholder={placeholder}
        onChange={this.handleOnChange}
        value={inputValue}
      ></input>
    );
  }
}

export default ItemsFilter;
